import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Body3, H5 } from '../../themes/typography';
import { FooterLogo } from '../../assets/images';
import { companyName } from '../../app/store/constant';
import useAuthNavigation from '../../view/authentication/useAuthNavigation';
import { Instagram, Facebook, LinkedIn } from '@mui/icons-material';
import '../../styles/components/Footer.css';

const Footer = () => {

    const navigate = useNavigate();
    const { openAuth } = useAuthNavigation();

    const { isLoggedIn, user } = useSelector((state) => state.auth);

    const handleCreateEventClick = (e) => {
        e.preventDefault();

        if (isLoggedIn && user?.id) {
            navigate('/event/new/event-details');
        } else {
            openAuth();
        }
    };

    return (
        <footer className="shmooz-footer">
            <div className="footer-container">

                <div className="footer-logo-section">

                    <Link href="/">
                        <div className="footer-logo">
                            <img src={FooterLogo} alt="Company Logo" />
                        </div>
                    </Link>

                    <div className="footer-logo-details">
                        <div>
                            <Body3>
                                🇮🇳 Made in India
                            </Body3>
                        </div>
                        <div>
                            <Body3>By{" "}
                                <Link href="/" className="company-link">
                                    {companyName}
                                </Link>
                            </Body3>
                        </div>
                        <div>
                            <Body3 fontWeight={500}>
                                © 2025 {companyName}. All rights reserved.
                            </Body3>
                        </div>
                    </div>

                </div>

                <div className="footer-links-container">

                    <div className="footer-column">
                        <H5>
                            Users
                        </H5>
                        <ul className="footer-links">
                            <li>
                                <Link to="/events">
                                    <Body3 className='social-link'>
                                        Events
                                    </Body3>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Organizers Column */}
                    <div className="footer-column">
                        <H5>
                            Organizers
                        </H5>
                        <ul className="footer-links">
                            <li>
                                <Link to="/event/new/event-details" onClick={handleCreateEventClick}>
                                    <Body3 className='social-link'>
                                        Create Event
                                    </Body3>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Company Column */}
                    <div className="footer-column">
                        <H5>Company</H5>
                        <ul className="footer-links">
                            <li>
                                <Link to="/pages/contact-us">
                                    <Body3 className='social-link'>
                                        Contact Us
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/pages/pricing"}>
                                    <Body3 className='social-link'>
                                        Pricing
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/pages/privacy-policy"}>
                                    <Body3 className='social-link'>
                                        Privacy Policy
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/pages/refund-policy"}>
                                    <Body3 className='social-link'>
                                        Refund & Cancellation Policy
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/pages/terms-and-conditions"}>
                                    <Body3 className='social-link'>
                                        Terms & Conditions
                                    </Body3>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Social Media Column */}
                    <div className="footer-column">
                        <H5>
                            Social Media
                        </H5>
                        <ul className="footer-links" style={{ alignItems: 'flex-start' }}>
                            <li>
                                <Link>
                                    <Body3 className="social-link">
                                        <Instagram color="secondary" />
                                        Instagram
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link>
                                    <Body3 className="social-link">
                                        <Facebook color="secondary" />
                                        Facebook
                                    </Body3>
                                </Link>
                            </li>
                            <li>
                                <Link>
                                    <Body3 className="social-link">
                                        <LinkedIn color="secondary" />
                                        LinkedIn
                                    </Body3>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer